import { UserManagementUpdate } from '@/features/user-management/user-management-update';

const UserManagementUpdatePage = () => {
  return <UserManagementUpdate />;
};

export default UserManagementUpdatePage;
